export default __webpack_public_path__ + "static/media/Andrea Chimenti.969b98d6.jpg";